import { ISourcingToolSearchFilter } from "react-migration/domains/search/typings/SourcingToolSpecificFilterTypes";
import { SearchType } from "react-migration/domains/search/constants/searchTypes";
import { ConstrainedListFilterMust } from "react-migration/domains/search/typings/SourcingToolFilters/types";
import Feature from "src/js/stores/user/Feature";

export const TrafficCountTypeFilter: ISourcingToolSearchFilter = {
  id: "traffic-count-type-id",
  type: "checkbox",
  must: ConstrainedListFilterMust.MATCH_ALL,
  mustOptions: [ConstrainedListFilterMust.MATCH_ALL, ConstrainedListFilterMust.MATCH_NONE],
  updateFilterDialogIsVisible: false,
  hideFilter: true,
  values: [
    {
      name: "All motor vehicles",
      key: "traffic_max_all_motor_vehicles",
      checked: false,
    },
    {
      name: "Cars and taxis",
      key: "traffic_max_cars_and_taxis",
      checked: false,
    },
    {
      name: "Cars, taxis, LGVs",
      key: "traffic_max_cars_taxis_lgvs",
      checked: false,
    },
    {
      name: "LGVs",
      key: "traffic_max_lgvs",
      checked: false,
    },
    {
      name: "Buses, coaches and HGVs",
      key: "traffic_max_buses_coaches_hgvs",
      checked: false,
    },
    {
      name: "HGVs",
      key: "traffic_max_all_hgvs",
      checked: false,
    },
  ],
};

export const TrafficCountNumberFilter: ISourcingToolSearchFilter = {
  id: "traffic-count-number-filter",
  field: "sidebar.react.search_sidebar.traffic_count_number",
  type: "number",
  displayMessages: {
    mustOption: "seems.pointless.empty_string",
  },
  rangeLimit: [0, null],
  unit: "number",
  unitLabel: "vehicles",
};

export const TrafficCountFilter: ISourcingToolSearchFilter = {
  id: "traffic-count-id",
  field: "sidebar.react.search_sidebar.traffic_count.title",
  type: "compound",
  must: "MATCH_ALL",
  mustOptions: ["MATCH_ALL"],
  filters: [TrafficCountTypeFilter, TrafficCountNumberFilter],
  requiredFilters: "all",
  searchTypes: [SearchType.SOURCING_TOOL_UK],
  displayMessages: {
    updateTitle: "sidebar.react.search_sidebar.distance_to_closest_traffic_count",
  },
};
